<template>
  <section
    class="overflow-hidden bg-white border shadow-sm rounded-2xl dark:bg-slate-900 border-slate-200 dark:border-slate-800"
  >
    <div
      class="flex items-center gap-2 px-5 py-2.5 text-sm font-medium border-b
             bg-slate-50/90 dark:bg-slate-800/80
             border-slate-100 dark:border-slate-800"
    >
      <!-- secondary bg + primary icon -->
      <span
        v-if="icon"
        class="inline-flex items-center justify-center w-8 h-8 rounded-full bg-secondary/15"
      >
        <i :class="icon" class="text-[16px] leading-none text-primary"></i>
      </span>

      <span class="text-slate-900 dark:text-white">
        {{ title }}
      </span>

      <span v-if="required" class="text-rose-500">*</span>
    </div>

    <div class="px-5 py-4">
      <slot />
    </div>
  </section>
</template>


<script>
export default {
  name: "CardSection",
  props: {
    title: { type: String, required: true },
    icon: { type: String, default: "" },
    required: { type: Boolean, default: false },

    // new: "primary" | "secondary"
    iconType: { type: String, default: "secondary" },
  },
  computed: {
    iconTypeClass() {
      return this.iconType === "primary"
        ? "bg-primary/10 text-primary"
        : "bg-secondary/10 text-secondary";
    },
  },
};
</script>
